// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3LXY8","vLegacy":"SelectSecondary_vLegacy__2t6bP","error":"SelectSecondary_error__1cF5M","disabled":"SelectSecondary_disabled___e2j-"};